import { render, staticRenderFns } from "./OptionSetting.vue?vue&type=template&id=0a70bddc&scoped=true&"
import script from "./OptionSetting.vue?vue&type=script&lang=js&"
export * from "./OptionSetting.vue?vue&type=script&lang=js&"
import style0 from "./OptionSetting.vue?vue&type=style&index=0&id=0a70bddc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a70bddc",
  null
  
)

export default component.exports